import baseScenario from './user';
import {
  BILLING_ACCOUNT_STATUS,
  BILLING_ON_DEMAND_STATUS,
} from 'billing-common/constants/status';
import getPlatformContext from '../helpers/get-platform-context';

let options = {
  createBilling: true,
  onDemandBillingMethodDetails: true,
  billingAccountOnDemandStatus: BILLING_ON_DEMAND_STATUS.ACTIVE,
  billingAccountStatus: BILLING_ACCOUNT_STATUS.ACTIVE,
};

export default function (server) {
  baseScenario(server, options);

  let { organization, project } = getPlatformContext(server);

  let billingAccount = server.schema.findBy('billing-account.billing-account', {
    organizationId: organization.id,
    projectIds: [project.id],
  });

  let runningStatement = server.schema.findBy(
    'billing-account.running-statement',
    {
      billingAccountId: billingAccount.id,
    }
  );

  runningStatement.update({
    total: '0.00',
    resources: [],
  });
}
